import portalApi from '../../../services/portal.axios';

async function getPersonas() {
  const { data } = await portalApi.get('/personas/');

  return data.data;
}

async function updatePersona(persona) {
  const { data } = await portalApi.put(`/personas/${persona.id}`, persona);

  return data.data;
}

async function getDocumentosByPersona(id) {
  const { data } = await portalApi.get(`/documentos/?persona_id=${id}`);

  return data.data;
}

async function getDocumentoFile(id) {
  const data = await portalApi.get(`/documentos/archivo/${id}`, { responseType: 'blob' });

  return data;
}

async function getEstudiosByPersona(id) {
  const { data } = await portalApi.get(`/estudios/?persona_id=${id}`);

  return data.data;
}

async function updateEstudio(estudio) {
  const { data } = await portalApi.put(`/estudios/${estudio.id}`, estudio);

  return data.data;
}

async function getReferenciasByPersona(id) {
  const { data } = await portalApi.get(`/referncias/?persona_id=${id}`);

  return data.data;
}

async function updateReferencia(referencia) {
  const { data } = await portalApi.put(`/referncias/${referencia.id}`, referencia);

  return data.data;
}

async function updateDocumento(documento) {
  const { data } = await portalApi.put(`/documentos/${documento.id}`, documento);

  return data.data;
}

async function notifyProcesoEvaluacion(avisoEvaluacion) {
  await portalApi.post('/personas/aviso_evaluacion', avisoEvaluacion);
}

export default function createPersonaApiRepository() {
  return {
    getPersonas,
    updatePersona,
    getDocumentosByPersona,
    getEstudiosByPersona,
    getReferenciasByPersona,
    updateEstudio,
    updateReferencia,
    getDocumentoFile,
    updateDocumento,
    notifyProcesoEvaluacion,
  };
}
